import { render, staticRenderFns } from "./AssignmentTableItem.vue?vue&type=template&id=91a81fcc&scoped=true&"
import script from "./AssignmentTableItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentTableItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTableItem.vue?vue&type=style&index=0&id=91a81fcc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a81fcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VIcon,VOverlay})
